module.exports = __webpack_public_path__ + "img/Inicio2.7d4f72a0.png";